import { render } from "./WhatsAppTemplatesView.vue?vue&type=template&id=d0381e3c&scoped=true"
import script from "./WhatsAppTemplatesView.vue?vue&type=script&lang=js"
export * from "./WhatsAppTemplatesView.vue?vue&type=script&lang=js"

import "./WhatsAppTemplatesView.vue?vue&type=style&index=0&id=d0381e3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0381e3c"]])

export default __exports__